// @ts-ignore
import { Badge, Flex, Popover } from 'antd';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { COLOR_TAG_TEXT_ERROR_HOVER, HEIGHT_ONE_PERCENT, MARKER_PADDING_TOP, STROKE_PARAM } from '../const';
import { ComponentsDispatch, RootState } from '../store';
import { setterGant } from '../store/slices/gantSlice';
import { ItemTaskType, ItemType, MappingItemIdIndexType } from '../types';
import GantButtonListOfTask from './gantButtonListOfTask';
import GantItemTask from './gantItemTask';

interface IGantItemGroupTask {
    groupTask: ItemTaskType[];
    positionX: number;
}

const GantItemGroupTask: React.FC<IGantItemGroupTask> = ({ groupTask, positionX }) => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const currentTask = useSelector<RootState, ItemTaskType | null>((state) => state.calendar.currentTask);
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const isGroupCurrentRef = useRef(false);

    const [task] = groupTask as ItemTaskType[];

    const handleShowListTask = () => {
        dispatch(
            setterGant({
                scheduleItemForListTaskShow: itemsList[mappingItemIdIndex[task.schedule_item_id!]],
                dayForListTaskShow: [task.datetime, task.datetime],
            }),
        );
    };

    const getContent = () => {
        isGroupCurrentRef.current = !!task.id && task.id === currentTask?.id;

        if (groupTask.length === 1) {
            return <GantItemTask key={task.datetime + task.id} subTask={task} />;
        }

        if (groupTask.length > 1) {
            return (
                <Flex vertical align={'center'} gap={10}>
                    <div>
                        Scheduled <Badge count={groupTask.length} /> tasks{' '}
                    </div>
                    <div>
                        <GantButtonListOfTask onClick={handleShowListTask} title={'see more ...'} />
                    </div>
                </Flex>
            );
        }

        return <></>;
    };

    return (
        <Popover key={task.datetime} content={<div style={{ width: 150 }}>{getContent()}</div>}>
            <circle
                cx={positionX}
                cy={HEIGHT_ONE_PERCENT * MARKER_PADDING_TOP}
                r="6"
                {...STROKE_PARAM}
                fill={isGroupCurrentRef.current ? COLOR_TAG_TEXT_ERROR_HOVER : '#f5f5f5'}
                stroke={isGroupCurrentRef.current ? COLOR_TAG_TEXT_ERROR_HOVER : 'black'}
            />
        </Popover>
    );
};

export default GantItemGroupTask;
